var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgListIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 17
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#listIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11 .31H6c-1.103 0-2 .896-2 2v9c0 1.102.897 2 2 2h7c1.103 0 2-.898 2-2v-7h-3c-.553 0-1-.447-1-1v-3Zm4 3-1-1-1-1-1-1v2.999h3Zm-12.5.75a.748.748 0 0 0-.75-.75.748.748 0 0 0-.75.75v8a4.25 4.25 0 0 0 4.25 4.25h6c.416 0 .75-.335.75-.75a.748.748 0 0 0-.75-.75h-6a2.75 2.75 0 0 1-2.75-2.75v-8Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "listIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .31h16v16H0z"
})))));
export default SvgListIcon;